// extracted by mini-css-extract-plugin
export default {"searchbar-input":"input_searchbar-input__FNdRO","searchbar-input__icon":"input_searchbar-input__icon__tZVFE","searchbar-input__input":"input_searchbar-input__input__DDL0T"};